// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__J-Pf4"};